import { useTranslation } from 'react-i18next';
import { useNotification } from 'spindl-shared-components';
import { NOTIFICATION_DURATION } from '../constants';
import { copyAndFormatJSON } from '../utils';

export const useCopyJSON = () => {
  const { t } = useTranslation();
  const { trigger } = useNotification();

  const copyJSON = async (textValue: string) => {
    await copyAndFormatJSON(textValue);
    trigger({
      message: t('database_page.notifications.json_copy'),
      type: 'Positive',
      duration: NOTIFICATION_DURATION,
    });
  };

  return {
    copyJSON,
  };
};
